/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path d="M74.726 79.393c0 20.077-16.275 36.352-36.352 36.352-20.104 0-36.38-16.275-36.38-36.352 0-20.077 16.276-36.352 36.38-36.352 20.077 0 36.352 16.275 36.352 36.352M490.27 100.517H167.494c-11.657 0-21.118-9.461-21.118-21.118 0-11.658 9.46-21.119 21.118-21.119H490.27c11.658 0 21.119 9.461 21.119 21.119 0 11.657-9.461 21.118-21.119 21.118M490.27 453.118H167.494c-11.657 0-21.118-9.46-21.118-21.118 0-11.658 9.46-21.119 21.118-21.119H490.27c11.658 0 21.119 9.461 21.119 21.119 0 11.657-9.461 21.118-21.119 21.118M489.892 275.237H167.118c-11.657 0-21.118-9.461-21.118-21.119 0-11.657 9.461-21.118 21.118-21.118h322.774c11.658 0 21.119 9.461 21.119 21.118 0 11.658-9.461 21.119-21.119 21.119M74.732 253.352c0 20.076-16.275 36.352-36.352 36.352-20.105 0-36.38-16.276-36.38-36.352C2 233.275 18.275 217 38.38 217c20.077 0 36.352 16.275 36.352 36.352M74.726 432.005c0 20.077-16.275 36.352-36.352 36.352-20.104 0-36.38-16.275-36.38-36.352 0-20.076 16.276-36.352 36.38-36.352 20.077 0 36.352 16.276 36.352 36.352" />
    </g>
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconBrowse = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconBrowse.defaultProps = {
  theme,
};
IconBrowse.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconBrowse.displayName = 'IconBrowse';
export { IconBrowse };
